module.exports = __webpack_public_path__ + "img/02.56b44686.svg";